import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconUsers } from '@sorare/core/src/atoms/icons/system/iconUsers.ts';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';

type Props = {
  membersCount: number;
  maxMembersCount: number;
};

export const SquadMembersCount = ({ membersCount, maxMembersCount }: Props) => (
  <Horizontal gap={0.5} center>
    <FontAwesomeIcon icon={iconUsers} size="xs" color="var(--c-nd-600)" />
    <LabelL color="var(--c-nd-600)">
      {membersCount}/{maxMembersCount}
    </LabelL>
  </Horizontal>
);
